// --- API Hooks ---
import { useSubscribeToStockNotificationMutation } from "../templates/ecommerce/stockNotification/api/stockNotificationApi";

// --- Custom Logic Hooks ---
import { useStockNotification } from "../templates/ecommerce/stockNotification/hooks/useStockNotification";
import { useOpenStockNotificationModal } from "../templates/ecommerce/stockNotification/hooks/useOpenStockNotificationModal";

// --- UI Components ---
import StockNotificationForm from "../templates/ecommerce/stockNotification/components/StockNotificationForm";

export const stockNotification = {
  api: {
    useSubscribeToStockNotificationMutation,
  },
  hooks: {
    useStockNotification,
    useOpenStockNotificationModal,
  },
  components: {
    StockNotificationForm,
  },
};
